import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'magnific-popup';

// import aboutimg from '../../../assets/img/text-block/05.jpg';
import videobg from '../../../assets/img/text-block/04.jpg';

const featuresposts = [
    { icon: 'flaticon-ring', title: 'Diamond Ring' },
    { icon: 'flaticon-bracelet', title: 'Bracelets' },
    { icon: 'flaticon-necklace', title: 'Necklaces' },
    { icon: 'flaticon-bracelet-2', title: 'Pendants' },
    { icon: 'flaticon-earrings', title: 'Earrings' },
];
class About extends Component {
    componentDidMount(){
        function popup(){
            $('.popup-video').magnificPopup({
                type: 'iframe',
            });
        }
        popup();
    }
    render() {
        return (
            <section className="about-section pt-115 pb-115">
                <div className="container">
                    <div className="video-wrap video-wrap-two video-about mb-60" style={{ backgroundImage: "url(" + videobg + ")" }}>
                        <Link to="http://www.youtube.com/embed/watch?v=EEJFMdfraVY" className="popup-video"><i className="fas fa-play" /></Link>
                    </div>
                    {/* <div className="section-title about-title text-center">
                        <span className="title-tag">since <span>1994</span></span>
                        <h2>Hello. Our store has been present for over 30 years . We give assurance to all customers.</h2>
                    </div> */}
                    <div className="section-title about-title text-center">
                        <span className="title-tag">Since <span>1994</span></span>

                        <h4>Over 30 Years of Timeless Beauty & Trust</h4>

                        <p className="mt-4">
                            For over 30 years, we have been dedicated to bringing timeless beauty, craftsmanship,
                            and trust to every piece of jewellery we offer. Established with a passion for fine
                            artistry and a commitment to exceptional service, we have grown into one of the
                            region’s most trusted jewellery retailers.
                        </p>

                        <p>
                            We specialize in 22K authentic wedding jewellery, offering exquisite craftsmanship
                            that reflects tradition, elegance, and purity. Along with our signature bridal
                            collections, we also provide a wide range of diamond jewellery, gold and silver
                            articles, and premium gift items—making us a trusted destination for every
                            celebration and special occasion.
                        </p>

                        <p>
                            At our core, we believe jewellery is more than an accessory—it is a symbol of love,
                            celebration, memories, and personal expression. From classic gold and diamond pieces
                            to contemporary designs, every item in our collection is crafted to meet the highest
                            standards of quality and elegance.
                        </p>

                        <div className="mt-4">
                            <h4>Why Customers Trust Us</h4>
                            <p>✨ Premium quality jewellery</p>
                            <p>✨ Transparent pricing and certified materials</p>
                            <p>✨ Expert craftsmanship and custom-made designs</p>
                            <p>✨ Personalized service and knowledgeable guidance</p>
                        </div>

                        <div className="mt-4">
                            <h4>Our Vision</h4>
                            <p>
                                To be a trusted partner in life’s happiest moments, offering exquisite jewellery
                                that reflects beauty, authenticity, and emotional connection.
                            </p>
                        </div>

                        <div className="mt-4">
                            <h4>Our Success</h4>
                            <p>
                                We attribute our success to our commitment to satisfying every customer’s needs—
                                offering exquisite craftsmanship, honest guidance, and a seamless shopping
                                experience from start to finish.
                            </p>
                        </div>
                    </div>
                    <ul className="about-features">
                        {featuresposts.map((item,i) => (
                        <li key={i}>
                            <Link to="#">
                                <i className={item.icon} />
                                <i className={"hover-icon "+ item.icon +""} />
                                <span className="title">{item.title}</span>
                            </Link>
                        </li>
                        ))}
                    </ul>
                    {/* <div className="about-text-box">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="about-img">
                                    <img src={aboutimg} alt="images" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-text">
                                    <span>Get 50 % Off</span>
                                    <h3>Get All Gold Jewelry At 50 Percent, Grab It Now </h3>
                                    <p className="mb-4">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tem por incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip. </p>
                                    <h3>Get All Gold Jewelry At 50 Percent, Grab It Now </h3>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section >
        );
    }
}

export default About;